// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '안국뉴팜',
  targetSheetName: '법인용',
  headerRowIndex: 7,
  headerRowCount: 1,
  dataStartRowIndex: 8,
  columnMapping: {
    drugCode: '보험코드',
    price: '보험약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '질환명',
    '성분',
    '함량',
    '규격',
    '생산구분',
    '생동',
    '제품',
    '보험코드',
    '보험약가',
    '수수료',
    '오리지널 제품',
    '비고',
  ],
});
